import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import axios from 'axios';
import { MessageBox } from 'element-ui';
import store from '@/store';
import { getToken, getExpire } from '@/utils/auth';
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});
var isRefreshing = false;
var requests = [];
service.interceptors.request.use(function (config) {
  // do something before request is sent
  if (store.getters.token) {
    config.headers['Authorization'] = getToken(); // Bearer
  }
  if (config.url.indexOf('/refresh_token') >= 0 || config.url.indexOf('/login') >= 0) {
    return config;
  }
  if (store.getters.token && getExpire()) {
    if (getExpire() - new Date().getTime() <= 3600000) {
      // 立即刷新token
      if (!isRefreshing) {
        console.log('刷新token ing');
        isRefreshing = true;
        store.dispatch('user/refreshToken').then(function (res) {
          isRefreshing = false;
          return res.data.token;
        }).then(function (response) {
          console.log('刷新token成功，执行队列');
          requests.forEach(function (cb) {
            return cb(response);
          });
          // 执行完成后，清空队列
          requests = [];
        }).catch(function (res) {
          console.error('refresh token error: ', res);
        });
      }
      var retryOriginalRequest = new _Promise(function (resolve) {
        requests.push(function (token) {
          // 因为config中的token是旧的，所以刷新token后要将新token传进来
          config.headers['Authorization'] = 'Bearer ' + token;
          resolve(config);
        });
      });
      return retryOriginalRequest;
    }
  }
  return config;
}, function (error) {
  return _Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
*/

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  var res = response.data;
  // if the custom code is not 20000, it is judged as an error.
  if (response.status && response.status !== 200) {
    return _Promise.reject(res.message || 'error');
  } else {
    return _Promise.resolve(res);
  }
}, /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(error) {
    var msgData;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          msgData = error.response.data;
          if (error.response.status === 401 && msgData.error_code === '40301') {
            store.dispatch('user/resetToken');
            window.location.reload();
          } else if (msgData.code !== undefined && msgData.code !== '40301' && error.response.status === 400) {
            MessageBox.alert(msgData.message, '', {
              confirmButtonText: '确定',
              type: 'warning'
            });
          }
          return _context.abrupt("return", _Promise.reject(error));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
export default service;